<div class="bloco">
  <h5 class="titulo">Natureza Jurídica</h5>
  <div *ngIf="naoEncontrouRegistros">
      <div class="row">
        <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
      </div>
  </div>
  <div *ngIf="naoSolicitou">
      <div class="row">
          <div class="col-auto item">Você não solicitou essa consulta.</div>
        <!-- <div class="col-auto item"><button (click)="consultar()" [disabled]="consultando" class="btn btn-primary"><i class="fas fa-search"></i> Você não solicitou essa consulta. {{txtButtonConsultar}}</button></div> -->
      </div>
  </div>
  <div *ngIf="dados.natureza_juridica">
    <div class="row">
      <table class="table table-sm ">
        <thead>
          <tr>
            <th>Cod. Natureza</th>
            <th>Natureza Jurídica</th>
            <th>Grupo Natureza</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{dados.natureza_juridica.codigo_natureza}}</td>
            <td>{{dados.natureza_juridica.natureza_juridica}}</td>
            <td>{{dados.natureza_juridica.grupo_natureza}}</td>
            
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
  
  